export default "__VITE_ASSET__CPVmXIqi__"